// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"600dc94b","142":"ae0cc94b","169":"3de78cec","649":"77534159","654":"63ebeb6a","810":"5d4ca76f"}[chunkId] + ".chunk.js";
};